export default {

  /**
   * Create an object of an array.
   *
   * @param {Array} array - The array to sort.
   * @param {string} key - The name of the key that will be used as the root parent key
   * @returns {object}
   */
  arrayToObject: (array, key = 'id') => Object.assign({}, ...array.map((obj) => ({ [obj[key]]: obj }))),

  /**
   * Rollup Values
   *
   * @param {Array} array
   * @returns {Array} ranges
   */
  getRanges(array) {
    const ranges = [];
    let rstart;
    let rend;
    for (let i = 0; i < array.length; i += 1) {
      rstart = array[i];
      rend = rstart;
      while (array[i + 1] - array[i] === 1) {
        rend = array[i + 1]; // increment the index if the numbers sequential
        i += 1;
      }
      ranges.push(rstart === rend ? `${rstart}` : `${rstart}-${rend}`);
    }
    return ranges;
  },

  /**
   * Format a number with a bunch of options
   *
   * @param {number} amount
   * @param {string} prepend
   * @param {string} append
   * @param {number} decimalCountParam
   * @param {boolean} showZeroes
   * @param {string} decimalParam
   * @param {string} thousands
   * @returns {string}
   */
  formatNumber(
    amount,
    prepend = '',
    append = '',
    decimalCountParam = 2,
    showZeroes = true,
    decimalParam = '.',
    thousands = ',',
  ) {
    try {
      const absDecimalCount = Math.abs(decimalCountParam);
      const decimalCount = Number.isNaN(absDecimalCount) ? 2 : absDecimalCount;
      const integers = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
      const integersSplit = integers.length > 3 ? integers.length % 3 : 0;
      const negativeSign = amount < 0 ? '-' : '';
      let decimals = decimalCount
        ? decimalParam + Math.abs(amount - integers).toFixed(decimalCount).slice(-decimalCount)
        : '';

      if (!showZeroes) {
        // trim zeroes
        decimals = decimals.replace(/0+$/, '');
        if (decimals.length === 1) {
          // if there's only a period left
          decimals = '';
        }
      }

      return negativeSign
        + prepend
        + (integersSplit ? integers.substr(0, integersSplit) + thousands : '')
        + integers.substr(integersSplit).replace(/(\d{3})(?=\d)/g, `$1${thousands}`)
        + decimals
        + append;
    } catch (error) {
      return amount;
    }
  },
  /**
   * Sort an array of objects
   *
   * @param {Array} array - The array to sort.
   * @param {string} sortKey - The name of the key that will be used to sort.
   * @param {string} sortDirection - 'asc' || 'desc'
   * I looked into adding an `isDate` here but looking through
   * https://stackoverflow.com/questions/10123953/how-to-sort-an-array-by-a-date-property,
   * using `dateA - dateB` is more of a memory hog.
   * @returns {Array}
   */
  sortObjects(
    array,
    sortKey = 'name',
    sortDirection = 'asc',
  ) {
    return [...array].sort((a, b) => {
      let keyA = a[sortKey];
      let keyB = b[sortKey];

      if (sortDirection === 'desc') {
        keyA = b[sortKey];
        keyB = a[sortKey];
      }

      // The the value to sort by is an integer, subtract.
      if (Number.isInteger(keyA) && Number.isInteger(keyB)) {
        return keyA - keyB;
      }

      // The the value exists (not undefined, null, etc, uppercase strings to test.
      if (typeof keyA === 'string' && typeof keyB === 'string') {
        keyA = keyA.toUpperCase();
        keyB = keyB.toUpperCase();
      }

      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  },
};
